import Scalar from "src/libs/scalars/scalars/Scalar"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"
import { useState } from "react"

/* Protopia Ecosystem component */
export interface IRatingScalarProps extends ICompositeWidgetProps {
   
}
const RatingScalar = (props: IRatingScalarProps): JSX.Element => {
    return <>
        <Scalar 
            title={props.title}
            subtitle={props.subtitle}
            value={props.value}
            editable={props.editable}
            notClear
            enabledForm={<RatingDisable {...props}  />}  
            desabledForm={<RatingDisable {...props} />}  
            subMenus={props.subMenus}
            onSubMenu={props.onSubmenu} 
        />
    </>
}
const RatingDisable = (props: IRatingScalarProps): JSX.Element => {
    const getVal = (): any[] => {
        return (
            Array.isArray(props.value || props.default)
                ?
                props.value || props.default
                :
                []
        )
    }
    const getExtValue = (): number => {
        let val: any[] = getVal()
        return !!val.length ? ( val.reduce((sum, rating) => sum + rating.rating, 0) ) / val.length : 0
    }
    const [value, setValue] = useState<number>( getExtValue() )
    return <div className="p-3">
        <div className="lead"> { value } </div> 
    </div>
}
export default RatingScalar